
import PageContext from '../../mixins/page-context'
import { isEqual } from 'vessel/utils'

export default {
  name: 'SearchFilter',
  inheritAttrs: false,
  mixins: [PageContext],
  props: {
    value: {
      type: String,
      default: null
    },
    examples: {
      type: Array,
      default: () => []
    },
    global: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: null
    }
  },
  vessel: {
    example: {
      fontSize: 'sm'
    },
    link: {
      color: 'primary',
      cursor: 'pointer'
    }
  },
  watch: {
    value(newVal) {
      if (!isEqual(this.search, newVal)) {
        this.search = newVal
      }
    }
  },
  data() {
    return {
      search: this.value
    }
  },
  computed: {
    suggestions() {
      return this.$page.searchSuggestions || []
    }
  },
  methods: {
    exampleText(item, index, items) {
      return (index + 1) < items.length ? `${item}, ` : item
    },
    focusInput() {
      this.$refs.input.focus()
    },
    onKeyup() {
      this.onChange(this.search)
    },
    onClick(value) {
      this.search = value
      this.onChange(value)
    },
    onChange(value) {
      this.updateFilter(value)
    }
  }
}
